import React, { useId } from 'react';

/**
 * Full, half, or empty circle. The half state is a filled semicircle,
 * so greyscale and high contrast still show the split without a tint.
 */
export default function StoryProgressMark({ state }) {
  const clipId = `story-progress-half-${useId().replace(/:/g, '')}`;
  const full = state === 'full';
  const half = state === 'half';
  return (
    <svg
      className={`story-progress__mark story-progress__mark--${state || 'empty'}`}
      viewBox="0 0 16 16"
      width="18"
      height="18"
      aria-hidden="true"
      data-state={state || 'empty'}
    >
      {half && (
        <defs>
          <clipPath id={clipId}>
            <rect x="0" y="0" width="8" height="16" />
          </clipPath>
        </defs>
      )}
      <circle
        cx="8"
        cy="8"
        r="6.25"
        fill={full ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="1.5"
      />
      {half && (
        <circle
          cx="8"
          cy="8"
          r="6.25"
          fill="currentColor"
          clipPath={`url(#${clipId})`}
          data-half="true"
        />
      )}
    </svg>
  );
}
